import React, {Component} from "react";
import PropTypes from 'prop-types';
import * as Util from "../Framework/Util";
import AsyncSelect from 'react-select/lib/Async';
import * as ServerResponseHandler from "../Framework/ServerResponseHandler";
import _ from "lodash";

export default class SelectPtoRule extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ptoRuleId: '',
            ptoRule: this.props.ptoRule
        }
    }

    handleChange = newPtoRule => {
        // If the user backspaces all the way, newPtoRule becomes an empty array which errors out in the props.onChange method
        if (newPtoRule && newPtoRule.constructor === Array) {
            newPtoRule = null;
        }

        if (newPtoRule) {
            this.setState({
                ptoRuleId: newPtoRule.id,
                ptoRule: newPtoRule
            });
        } else {
            this.setState({
                ptoRuleId: '',
                ptoRule: null
            });
        }

        this.props.onChange(newPtoRule);
    };

    loadPtoRules = input => {
        const apiUrl = Util.apiSearchUrl(`pto_rule`, {data: input});
        return fetch(apiUrl, {credentials: 'include'})
            .then(response => ServerResponseHandler.getResponse(response))
            .then(json => {
                return _.filter(json.resultList, function(o) { return (o.deletedOn === null)})
            })
            .catch(error => ServerResponseHandler.handleError(error));
    };

    render() {
        return (
            <div className="fb-select">
                <AsyncSelect
                    cacheOptions
                    defaultOptions
                    isClearable
                    value={this.state.ptoRule}
                    noOptionsMessage={() => 'No Pto Rules found'}
                    getOptionValue={(option) => option.id}
                    getOptionLabel={(option) => option.name}
                    loadOptions={this.loadPtoRules}
                    placeholder={'Select an Pto Rule...'}
                    onChange={this.handleChange}
                />
            </div>
        )
    }
}

SelectPtoRule.propTypes = {
    onChange: PropTypes.func.isRequired,
    ptoRule: PropTypes.object
};